var render = function render(){var _vm=this,_c=_vm._self._c;return _c('messenger',_vm._b({attrs:{"account":_vm.account,"model":_vm.mission,"type":"missions"}},'messenger',{data: _vm.data},false))
}
var staticRenderFns = []

export { render, staticRenderFns }